export default "__VITE_ASSET__DAFexBUB__"